import React, { useContext } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CustomDialog, DialogTitle, DialogContent, DialogActions } from '@components-clean/legacy/core/legacy-dialog';
import SaveButton from '@components-clean/legacy/sign-out/save-button';
import { UserContext } from '@contexts/user-context';
import { useTranslation } from '@hooks/index';
import doLogout from '@utils/auth.service';

type Props = {
    open: boolean;
    onClose: () => void;
};

const SignOut = ({ open, onClose }: Props) => {
    const { t } = useTranslation();
    const user = useContext(UserContext);
    const client = useApolloClient();

    const logout = () => {
        onClose();
        doLogout(client, user, 'SignOut');
    };

    return (
        <CustomDialog
            onClose={onClose}
            aria-labelledby="sign-out-title"
            fullWidth
            scroll="paper"
            maxWidth="sm"
            open={open}
        >
            <DialogTitle id="sign-out-title" style={{ width: 'auto' }}>
                {t('signOut')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={onClose}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent style={{ padding: 20, paddingBottom: 50, width: 'auto' }}>
                <span className="confirm-text" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {t('areYouSureToSignOut')}
                </span>
            </DialogContent>

            <DialogActions
                className="actions-info-wrapper-edit-cv actions-unassign-risk flex-end"
                style={{ paddingLeft: 20, paddingRight: 20, width: 'auto' }}
            >
                <SaveButton id="sign-out-btn" text="common:signOut" onClick={logout} />
            </DialogActions>
        </CustomDialog>
    );
};

export default SignOut;
